module.exports = __webpack_public_path__ + "static/Graphik-Black-Web-af1250fa7e09e1c7e866428d1910c74f.woff2";